module.exports = __webpack_public_path__ + "media/src/assets/Images/NewMessage-252951655218be30cbbc957ef7994822.svg";